import { GridColDef } from "@mui/x-data-grid";
import { MenuItem, Select } from "@mui/material";
import ConfirmActionButton from "../../../components/Fleet/ConfirmActionButton/ConfirmActionButton";
import UpdateHarshEventPopup from "../../../components/Fleet/HarshEvent/UpdateHarshEventPopup/UpdateHarshEventPopup";
import HarshEventNotesButton from "../../../components/Fleet/HarshEvent/HarshEventNotesButton/HarshEventNotesButton";
import HarshEventStatusChip from "../../../components/Fleet/HarshEvent/HarshEventStatusChip/HarshEventStatusChip";

export const getHarshEventsTableColumns = (): GridColDef[] => [
  {
    field: "date",
    headerName: "Date",
    width: 150,
    type: "date",
    valueGetter: (params) => {
      const value = params;
      return value ? new Date(value) : null;
    },
  },
  { field: "harshEventType", headerName: "Type", width: 200 },
  { field: "driverName", headerName: "Driver", width: 200 },
  { field: "truckUnitNumber", headerName: "Truck", width: 150 },
  {
    field: "status",
    headerName: "Status",
    width: 150,
    editable: true,
    renderCell: (params) => <HarshEventStatusChip value={params.value} />,
    renderEditCell: (params) => (
      <Select
        onChange={(event) =>
          params.api.setEditCellValue(
            { id: params.id, field: params.field, value: event.target.value },
            event as any
          )
        }
        defaultValue={params.value || "Pending"}
        fullWidth
      >
        <MenuItem value="Pending">Pending</MenuItem>
        <MenuItem value="Completed">Completed</MenuItem>
        <MenuItem value="NoAnswer">No Answer</MenuItem>
      </Select>
    ),
    valueFormatter: (value) => {
      if (value === "Pending") return "Pending";
      if (value === "Completed") return "Completed";
      if (value === "NoAnswer") return "No Answer";
      return value as any;
    },
  },
  { field: "addedBy", headerName: "Added By", width: 150 },
  {
    field: "notes",
    headerName: "Notes",
    width: 150,
    sortable: false,
    renderCell: (params) => (
      <HarshEventNotesButton harshEventId={params.row.id} />
    ),
  },
  {
    field: "update",
    headerName: "Update",
    width: 150,
    sortable: false,
    renderCell: (params) => <UpdateHarshEventPopup harshEvent={params.row} />,
  },
  {
    field: "delete",
    headerName: "Delete",
    width: 150,
    sortable: false,
    renderCell: (params) => (
      <ConfirmActionButton
        id={params.row.id}
        entityType="HarshEvent"
        actionType="delete"
        entityLabel="Harsh Event"
        queryKey="harshEvents"
        buttonLabel="Delete"
      />
    ),
  },
];
